"use client";

import React from "react";
import { Scissors, RefreshCw, Crown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "KNIP & SPAAR",
  description: "Bezoek onze barbershop voor een frisse look en spaar direct punten bij elke behandeling.",
  icon: Scissors
}, {
  title: "AUTOMATISCH",
  description: "Vanaf 2025 worden uw punten automatisch gesynchroniseerd met ons nieuwe online boekingssysteem.",
  icon: RefreshCw
}, {
  title: "GRATIS BEHANDELING",
  description: "Wissel uw gespaarde punten in voor een gratis knipbeurt of exclusieve verzorgingsproducten.",
  icon: Crown
}];
function StepCard({
  step,
  index
}: {
  step: typeof steps[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const Icon = step.icon;
  return <div ref={ref} className={`flex flex-col items-center text-center space-y-5 transition-all duration-700 ease-out hover:scale-[1.02] group ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      <div className="relative flex h-24 w-24 items-center justify-center rounded-md border border-white/10 group-hover:border-primary/50 transition-colors duration-300 !bg-[hsl(0,0%,0%)]">
        <div className="absolute -top-2 -right-2 flex h-8 w-8 items-center justify-center rounded-md bg-primary text-primary-foreground font-default font-bold text-sm shadow-md">
          {index + 1}
        </div>
        <Icon className="h-12 w-12 text-primary stroke-[1.5]" />
        <span className="absolute inset-0 flex items-center justify-center text-6xl font-default font-bold text-foreground/5 -z-10 select-none">
          0{index + 1}
        </span>
      </div>
      
      <div className="space-y-2">
        <h3 className="font-default text-xl font-bold uppercase tracking-wider !text-[hsl(350,89%,60%)]">
          {step.title}
        </h3>
        <p className="text-sm leading-relaxed max-w-[280px] mx-auto font-sans !text-[hsl(55,97%,88%)]">
          {step.description}
        </p>
      </div>
    </div>;
}
export default function HowItWorks() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="263156" id="how-it-works" className="py-20 overflow-hidden !bg-[hsl(0,0%,0%)] md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-16 md:mb-24 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4 tracking-tighter uppercase">
            Hoe Het Werkt
          </h2>
          <p className="text-lg max-w-2xl font-sans font-light !text-[hsl(48,96%,89%)] md:text-xl">
            Eenvoudig sparen voor uw volgende meesterwerk
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 max-w-5xl mx-auto">
          {steps.map((step, i) => <div key={i} data-index={i}>
              <StepCard step={step} index={i} />
            </div>)}
        </div>
      </div>
    </section>;
}